import {getGreenCourse} from '@/api/Courses/GetGreenCourse'
import {submitGreenCourse} from '@/api/Courses/SubmitGreenCourse'
import {getCourses} from '@/api/Courses/GetCourses'
import {getCourseById} from '@/api/Courses/GetCourseById'
import {getCourseLocations} from '@/api/Courses/GetCourseLocations'

export default {
    state: {
        course: null,
        wrongAnswersQuestionIds: null
    },
    getters: {
        getCourse: (state) => {
            if (state.course) return state.course

            // if (localStorage.getItem('course')) state.course = JSON.parse(localStorage.getItem('course'))

            return state.course
        },
        getWrongAnswersQuestionIds: (state) => {
            if (state.wrongAnswersQuestionIds) return state.wrongAnswersQuestionIds

            // if (localStorage.getItem('wrongAnswersQuestionIds'))
            //     state.wrongAnswersQuestionIds = JSON.parse(localStorage.getItem('wrongAnswersQuestionIds'))

            return state.wrongAnswersQuestionIds
        }
    },
    mutations: {
        setCourse: (state, course) => {
            state.course = course
            // localStorage.setItem('course', JSON.stringify(course))
        },
        updateCourse: (state, course) => {
            state.course = course

            // localStorage.setItem('course', JSON.stringify(course))
        },
        resetCourse: (state) => {
            state.course = null

            localStorage.removeItem('course')
        },
        setWrongAnswersQuestionIds: (state, wrongAnswersQuestionIds) => {
            state.wrongAnswersQuestionIds = wrongAnswersQuestionIds

            // localStorage.setItem('wrongAnswersQuestionIds', JSON.stringify(wrongAnswersQuestionIds))
        },
        resetWrongAnswersQuestionIds: (state) => {
            state.wrongAnswersQuestionIds = null

            // localStorage.removeItem('wrongAnswersQuestionIds')
        }
    },
    actions: {
        fetchGreenCourse: async ({commit}, {locationId}) => {
            const course = await getGreenCourse(locationId)
            commit('setCourse', course.data)

            return course.data
        },
        submitGreenCourse: async (_, {courseId, questions}) => {
            const response = await submitGreenCourse(courseId, questions)

            return response.data
        },
        fetchCourses: async (_,) => {
            const courses = await getCourses()

            return courses.data
        },
        fetchCourseById: async ({commit}, {courseId}) => {
            const course = await getCourseById(courseId)
            commit('setCourse', course.data)

          return course.data
        },
        fetchCourseLocations: async ({commit}, {courseId}) => {
            const locations = await getCourseLocations(courseId)
            return locations.data
        },
    }
}
